import { render } from "./routerBody.vue?vue&type=template&id=4f46f136&scoped=true"
import script from "./routerBody.vue?vue&type=script&lang=js"
export * from "./routerBody.vue?vue&type=script&lang=js"

import "./routerBody.vue?vue&type=style&index=0&id=4f46f136&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f46f136"]])

export default __exports__